<template>
  <a-space
    class="text-center text-12px w-full flex flex-wrap justify-center gap-2 sm:gap-4 py-4 flex-col sm:flex-row"
    direction="horizontal"
  >
    <template #split>
      <a-divider type="vertical" class="hidden sm:block" />
    </template>
    <span class="block sm:inline">{{ $t("layout.footer.copyright") }}</span>
    <a href="/terms" target="_blank" class="text-12px p-0! h-auto! color-p no-underline">
      {{ $t("layout.footer.terms") }}
    </a>
    <a href="/privacy" target="_blank" class="text-12px p-0! h-auto! color-p no-underline">
      {{ $t("layout.footer.privacy") }}
    </a>
    <!-- <TicketModal>
      <a-button type="link" class="text-12px p-0! h-auto!">
        {{ $t("layout.footer.help") }}
      </a-button>
    </TicketModal> -->
    <!-- <Lang class="hidden md:block" /> -->
  </a-space>
</template>
<script setup lang="ts"></script>
